import { useEffect, useState } from "react";
import { getScheduleById } from "../services/getScheduleById";
import { Schedule } from "../types";

export function useSchedule(scheduleId: string) {
  const [schedule, setSchedule] = useState<Schedule>({} as Schedule);
  const [loading, setLoading] = useState(true);

  async function asyncCall(showSpinner = true) {
    if (showSpinner) setLoading(true);
    if (!scheduleId) {
      setLoading(false);
      setSchedule({} as Schedule);
      return;
    }
    const sche = await getScheduleById(scheduleId);
    if (!sche) {
      setLoading(false);
      setSchedule({} as Schedule);
      return;
    }
    setSchedule(sche);
    setLoading(false);
  }

  useEffect(() => {
    asyncCall();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleId]);

  return { schedule, loading, refetch: asyncCall };
}
